import { Component, Input, OnInit } from '@angular/core';
import { RequirementService } from '../../___LOGIC/requirement.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-requirement-list',
  templateUrl: './requirement-list.component.html',
  styleUrls: ['./requirement-list.component.css']
})
export class RequirementListComponent implements OnInit {

  @Input() requisites;

  // NIE
  default = [
    {
      "id": "66",
      "priority": "1",
      "type": "step",
      "item": "Pasaporte válido",
      "description": "",
      "itemCategory": "",
      "steps": [
          {
              "id": "1",
              "step": "",
              "form": [],
              "progress": "",
              "description": "",
              "document": "",
              "checklist": [
                'Revisar la fecha de vencimiento',
              ]
          }
      ],
    },
    {
      "priority": "2",
      "type": "step",
      "item": "Rellenar formulario EX-15",
      "description": "",
      "itemCategory": "",
      "steps": [
          {
              "id": "1",
              "step": "Rellenar la hoja padronal formulario",
              "form": [],
              "progress": "",
              "description": "",
              "document": "",
              "checklist": [
                'Rellenar únicamente las casillas indicadas',
              ]
          }
      ],
    }
  ]

  status = 'read';


  selectedRequirement = null;
  newRequisite = {
    "priority": "",
    "type": "",
    "item": "",
    "description": "",
    "steps": [
      {
        "id": "",
        "step": "",
        "progress": "",
        "description": "",
        "document": "",
        "checklist": [
          { task: "", completed: false, dateCompleted: null }
        ]
      }
    ],
  };
  
  constructor(private requirementService: RequirementService,private router: Router){
    
  }

  ngOnInit(): void {
    if(!this.requisites){
      this.requisites = this.default;
    }
  }

  // Select a requisite to view details
  selectRequisite(requisite) {
    this.selectedRequirement = requisite;
  }

  openDetails(requirement){
    this.selectedRequirement = requirement;
    this.requirementService.setCurrentRequisite(requirement);
/*     this.router.navigateByUrl("requirement-step"); */
  }

  editRequirement(requirement){
    this.selectedRequirement = requirement;
    this.requirementService.setCurrentRequisite(requirement);
  }

  // Deselect to go back to the list view
  deselectRequisite() {
    this.selectedRequirement = null;
  }

  // Add a new requisite
  addRequisite() {
    this.requisites.push({...this.newRequisite});
    this.resetNewRequisite();
  }

  // Update a selected requisite
  updateRequisite() {
    // Logic for updating the requisite
  }

  // Delete a selected requisite
  deleteRequisite() {
    const index = this.requisites.indexOf(this.selectedRequirement);
    if (index > -1) {
      this.requisites.splice(index, 1);
      this.deselectRequisite();
    }
  }

  // Reset new requisite form
  resetNewRequisite() {
    this.newRequisite = {
      "priority": "",
      "type": "",
      "item": "",
      "description": "",
      "steps": [
        {
          "id": "",
          "step": "",
          "progress": "",
          "description": "",
          "document": "",
          "checklist": [
            { task: "", completed: false, dateCompleted: null }
          ]
        }
      ],
    };
  }

  calculateProgress(){
    let percentage;
    let total = 0;
    let completed = 0;

    for(let c of this.requisites){
      total++;
      if (c.completed === "1"){
        completed++;
      }
    }
    percentage = ((completed / total) * 100).toFixed(0);
    
    this.requisites = percentage;
  }
}